//Loại bảng tổng hợp
export default {
  // Các mã này đc cấu hình trong pa_layout_template trển db và không thay đổi trên db
  Luong_canBo: '30e8f64a-7d96-4f06-909f-037991e158ed', // Bảng lương cán bộ
  ChamCong_LamThemGio: '4b2d7bdc-01dc-47bc-9dee-9882a45f63ec', //   Làm thêm, làm đêm
  Luong_ThuNhapKhauTru: '517e1229-0c7e-4583-a0ac-671dc5dad817', // Bảng tổng hợp thu nhập, khấu trừ
  TruyLinh_LuongToiThieu: '58af5dc0-7c08-48bd-82a1-67c25d945707', // Bảng lương truy lĩnh mức lương tối thiểu
  Luong_BangLuong: '5cc75478-0b4e-4d9e-a4a2-65c9446c2755', // Bảng lương, phụ cấp
  Luong_LamThemGio: '6cfdbfac-6b7a-4234-8f35-1d6af02216e4', // Bảng thanh toán làm đêm, làm thêm giờ
  SalaryMS09: '93e54764-a3d5-4b3c-855f-75cbb7fdcf48', // Bảng lương dành cho mẫu 09
  Luong_TongHop: 'c231fe84-aac4-405f-8c52-07bc5e0a84b2', // Trả lương
  ChamCong_NgayNghi: 'c35f9158-6343-47d9-b0c5-330113f251a0', // Ngày nghỉ
  Thue_ThangQuy: 'cf012fb7-24e1-4c3b-a2b0-94977de12976', // Bảng tính thuế theo tháng, theo quý
  TruyLinh_LuongCanBo: 'd6630d4e-dc54-4db5-a7d8-6dd7ea543dd6', // Bảng lương truy lĩnh lương cán bộ
  Thue_Nam: 'dc1884b2-4635-4c4e-949a-f8c0591e2abd', // Bảng tính thuế cả nãm
  Luong_BangLuong_ST: 'eb38d542-5d93-45d3-a571-e14c67f1e3ea', // Bảng lương, phụ cấp (Mẫu số tiền)
};
